/* eslint-disable import/no-extraneous-dependencies */
// import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance } from "../../utils/axiosInstance"
// ----------------------------------------------------------------------

const url = process.env.BACKEND_URL;

const initialState = {
  isLoading: false,
  error: null,
  rentalBusListNew: [],
  rentalBusList: undefined,
  rentalBusListDetail: undefined,
  bookingRes: undefined,
  bookingCarRes: undefined,
  busCategoryRes: [],
};

const slice = createSlice({
  name: 'bus',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getRentalBusListNewSuccess(state, action) {
      state.isLoading = false;
      state.rentalBusListNew = action.payload;
    }, getRentalBusListSuccess(state, action) {
      state.isLoading = false;
      state.rentalBusList = action.payload;
    },
    // Get CarList
    getRentalBusDetailsNewSuccess(state, action) {
      state.isLoading = false;
      state.rentalBusListDetail = action.payload;
    },
    // Get CarList
    getRentalBusBookingNewSuccess(state, action) {
      state.isLoading = false;
      state.bookingRes = action.payload;
    },
    getRentalCarBookingNewSuccess(state, action) {
      state.isLoading = false;
      state.bookingCarRes = action.payload;
    },
    getSearchBusSuccess(state, action) {
      state.isLoading = false;
      state.busSearchRes = action.payload;
    },
    getBusCategorySuccess(state, action) {
      state.isLoading = false;
      state.busCategoryRes = action.payload;
    },
    getBusTypeSuccess(state, action) {
      state.isLoading = false;
      state.busTypeRes = action.payload;
    },
    getSearchBusFilterSuccess(state, action) {
      state.isLoading = false;
      state.busSearchFilterRes = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  createBilling,
  applyShipping,
  applyDiscount,
  increaseQuantity,
  decreaseQuantity,
} = slice.actions;

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export function getRentalBusListNew(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/bus/listBusPackages`,
        filterParam
      );

      dispatch(
        slice.actions.getRentalBusListNewSuccess(response.data.responseData)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getRentalBusList(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/bus/listBusPackages`,
        filterParam
      );

      dispatch(
        slice.actions.getRentalBusListSuccess(response.data)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getRentalBusDetails(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/bus/busDetails`, filterParam);

      dispatch(
        slice.actions.getRentalBusDetailsNewSuccess(
          response.data.busPackageDetails
        )
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getRentalBusBooking(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/booking/busBooking`,
        filterParam
      );

      dispatch(slice.actions.getRentalBusBookingNewSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getRentalCarBooking(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/booking/carBooking`,
        filterParam
      );

      dispatch(slice.actions.getRentalCarBookingNewSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchBus(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/bus/searchBus`,
        obj
      );
      dispatch(slice.actions.getSearchBusSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function busCategory(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.get(
        `${process.env.BACKEND_URL}/bus/getBusTypes`,
        obj
      );
      dispatch(slice.actions.getBusCategorySuccess(response.data.responseData));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function busTypes(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.get(
        `${process.env.BACKEND_URL}/bus/busTypes`,
        obj
      );
      dispatch(slice.actions.getBusTypeSuccess(response.data.responseData));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchBusFilter(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/bus/filterList`,
        obj
      );
      dispatch(
        slice.actions.getSearchBusFilterSuccess(response.data?.responseData)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
